import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, PlayIcon, RadioIcon, Share2Icon, UsersIcon } from 'lucide-react';
import { CtaBand } from '../components/ui/CtaBand';
import { events } from '../data/events';
import { policies } from '../data/policies';
const updates = [{
  time: '18:42',
  text: 'On jobs: “Five million formal jobs is not a slogan. It is an arithmetic claim, and the model is published.”'
}, {
  time: '18:27',
  text: 'Question from a Kaduna apprentice on technical education funding. Full answer to follow in the transcript.'
}, {
  time: '18:10',
  text: 'The candidate opens with the state of the manufacturing sector and the cost of unreliable power.'
}, {
  time: '18:00',
  text: 'The town hall has begun. Hall at capacity, overflow room opened.'
}];
export function Live() {
  const liveEvent = events[0];
  return <>
      <section className="bg-ink py-10 lg:py-14" aria-labelledby="live-heading" data-id="element-1012" data-mp="2e1suxp1vtv19">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1013" data-mp="13k7kmsdjxpc8">
          <p className="flex items-center gap-2.5" data-id="element-1014" data-mp="13l0o9kh7ryq5">
            <span className="flex items-center gap-1.5 rounded bg-red-600 px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-white" data-id="element-1015" data-mp="18jk7ve8c4yfc">
              <RadioIcon aria-hidden className="h-3 w-3" data-id="element-1016" data-mp="ullx0it83k4l" />
              Live now
            </span>
            <span className="text-[14px] text-white/60" data-id="element-1017" data-mp="yn7eyikm6oln">
              {liveEvent.city}, {liveEvent.state} · {liveEvent.time}
            </span>
          </p>
          <h1 id="live-heading" className="mt-4 max-w-[22ch] font-display text-[32px] leading-[1.08] text-white sm:text-[44px]" data-id="element-1018" data-mp="plhopg2gxvpg">
            {liveEvent.title}
          </h1>

          <div className="mt-8 grid gap-8 lg:grid-cols-12" data-id="element-1019" data-mp="fveoovwxjhhm">
            <div className="lg:col-span-8" data-id="element-1020" data-mp="1v3xfrrpk0vx">
              <div className="relative overflow-hidden rounded-media border border-white/10" data-id="element-1021" data-mp="1vdnffcr681m">
                <img src={liveEvent.image} alt="" className="aspect-video w-full object-cover opacity-70" data-id="element-1022" data-mp="6snbaqkhubnc" />
                <button type="button" aria-label="Play the live stream" className="absolute inset-0 flex items-center justify-center" data-id="element-1023" data-mp="23s5m5v54yj0w">
                  <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 text-ink transition-colors duration-150 ease-emphasis hover:bg-gold-400" data-id="element-1024" data-mp="1usqyf3gcsmk3">
                    <PlayIcon aria-hidden className="ml-1 h-6 w-6 fill-current" data-id="element-1025" data-mp="2midowc4xb7gk" />
                  </span>
                </button>
                <span className="absolute bottom-4 left-4 flex items-center gap-2 rounded bg-ink/80 px-3 py-1.5 text-[12px] font-semibold text-white" data-id="element-1026" data-mp="2ifz3bk9vdtll">
                  <UsersIcon aria-hidden className="h-3.5 w-3.5" data-id="element-1027" data-mp="17250i502cint" />
                  24,318 watching · captions on
                </span>
              </div>

              <div className="mt-5 flex flex-wrap items-center gap-3" data-id="element-1028" data-mp="121h4f4wz9bmq">
                <button type="button" className="inline-flex h-11 items-center gap-2 rounded-lg border border-white/30 px-5 text-[15px] font-semibold text-white transition-colors duration-150 ease-emphasis hover:bg-white/10" data-id="element-1029" data-mp="3dr6u8f8f4jw8">
                  <Share2Icon aria-hidden className="h-4 w-4" data-id="element-1030" data-mp="3ribvtmvcjm97" />
                  Share the stream
                </button>
                <Link to={`/events/${liveEvent.slug}`} className="inline-flex h-11 items-center gap-2 rounded-lg bg-green-600 px-5 text-[15px] font-semibold text-white transition-colors duration-150 ease-emphasis hover:bg-green-700" data-id="element-1031" data-mp="afvjnt2uedo">
                  Event details
                  <ArrowRightIcon aria-hidden className="h-4 w-4" data-id="element-1032" data-mp="eaqn6t27nwzw" />
                </Link>
              </div>
            </div>

            <aside className="lg:col-span-4" data-id="element-1033" data-mp="2c3eebof8albs">
              <div className="rounded-media border border-white/10 bg-ink-700 p-6" data-id="element-1034" data-mp="2g3ojwzz3z9q4">
                <h2 className="font-display text-[20px] text-white" data-id="element-1035" data-mp="1krxe9p9hsuzc">Live updates</h2>
                <ol className="mt-5 space-y-5" data-id="element-1036" data-mp="1gr55sy8g2u44">
                  {updates.map(update => <li key={update.time} className="border-l border-white/15 pl-4" data-id="element-1037" data-mp="1uqeap1r7a1ss">
                      <p className="text-[12px] font-bold uppercase tracking-[0.1em] text-gold-400" data-id="element-1038" data-mp="1uoa8qpcv3cv5">
                        {update.time} WAT
                      </p>
                      <p className="mt-1.5 text-[14px] leading-relaxed text-white/75" data-id="element-1039" data-mp="122idzx1ms9w0">
                        {update.text}
                      </p>
                    </li>)}
                </ol>
              </div>

              <div className="mt-5 rounded-media border border-white/10 p-6" data-id="element-1040" data-mp="17123u8jci5tn">
                <h2 className="font-display text-[18px] text-white" data-id="element-1041" data-mp="16yz3ovohawb7">Policies discussed tonight</h2>
                <ul className="mt-4 space-y-2" data-id="element-1042" data-mp="j9ekcboexx1e">
                  {policies.slice(0, 3).map(policy => <li key={policy.slug} data-id="element-1043" data-mp="eak2bby9scic">
                      <Link to={`/agenda/${policy.slug}`} className="flex items-center justify-between text-[15px] text-white/75 transition-colors duration-150 ease-emphasis hover:text-white" data-id="element-1044" data-mp="2pzhz9j7i0159">
                        {policy.title}
                        <ArrowRightIcon aria-hidden className="h-4 w-4 text-gold-400" data-id="element-1045" data-mp="2l1orwmugl13e" />
                      </Link>
                    </li>)}
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <CtaBand title="Watching from your ward?" description="Organise a viewing party, or volunteer to run one at the next town hall." primary={{
      label: 'Volunteer at events',
      to: '/join'
    }} secondary={{
      label: 'Campaign calendar',
      to: '/events'
    }} data-id="element-1046" data-mp="2zpjk824k13fy" />
    </>;
}